module.exports = __webpack_public_path__ + "static/media/conwx_metocean_logo.710dcc30.svg";